import './autoload'
import Vue from 'vue'
import axios from 'axios'
import router from './router'
import VueEventFormCreate from './modules/event-form/Create'
import VueEventFormEdit from './modules/event-form/Edit'

axios.defaults.headers.common['Authorization'] = `Bearer ${$('meta[name="api-token"]').attr('content')}`
axios.defaults.withCredentials = true

export default new Vue({
    components: {
		'vue-event-form-create': VueEventFormCreate,
		'vue-event-form-edit': VueEventFormEdit,
	},
    el: '#vue-app',
    router: router,
})